import { Meetings } from "@hedgefund/shared";
import React from "react";
import { useHistory } from "react-router";

const Meeting = () => {
  const history = useHistory();
  return <Meetings history={history} host={window._env_.ZOOM_URL} />;
};

export default Meeting;
